<template>
    <div v-if="company" class="animated fadeIn">
        <FactorsResult :company="company" :factors="factors" :colors="colors" :report="report" :comment="report.comment" ></FactorsResult>
        <b-row>
            <b-col sm="12">
                <b-card>
                    <div slot="header">
                        <router-link :to="'/diagnost/' + id">←	 Назад к диагностике компании &laquo;<small>{{company.name}}</small>&raquo;</router-link>
                    </div>
                    <b-form @submit.prevent="updateReport({reportData: factors, status: hasSuccess ? 'success' : (hasWarning ? 'warning' : 'danger'), isSend: true, comment: report.comment})">
                      <b-card :header-bg-variant="colors[key].status" v-for="(factor, key) in factors" :key="key">
                        <b-card-body>
                          <b-row>
                            <b-col>
                              <b-form-group>
                                <h4>{{factor.country.originalObject.country_name_ru}}</h4>
                                <div class="d-inline"><strong>Код ТН ВЭД:</strong>&nbsp;{{factor.code}}</div>&nbsp;
                                <div :class="'label bg-' + colors[key].status" class="d-inline">
                                  <i class="fa fa-exclamation"></i>&nbsp;
                                  {{ colors[key].statusText }}
                                </div>
                              </b-form-group>
                              <b-form-group :disabled="factor.isBlock || report.is_send">
                                <b-row>
                                  <b-col md="6">
                                    <label>Наименование товара:</label>
                                    <b-form-input :class="$v.factors.$each[key].product.$invalid ? 'is-invalid' : 'is-valid'" :required="!factor.isBlock" v-model="factor.product" type="text" placeholder="Введите товар" />
                                  </b-col>
                                  <b-col md="6"></b-col>
                                </b-row>
                              </b-form-group>
                              <b-form-group :disabled="factor.isBlock || report.is_send">
                                <b-row>
                                  <b-col md="6"><h5>Барьер</h5></b-col>
                                  <b-col md="6"><h5>Оценка</h5></b-col>
                                </b-row>
                                <b-row v-for="(bar,i) in factor.bars" :key="i">
                                  <b-col md="6">
                                    <b-form-group>
                                      <b-form-textarea v-model="bar.name" type="text" :class="$v.factors.$each[key].bars.$each[i].$invalid ? 'is-invalid' : 'is-valid'" :required="bar.status !== ''" placeholder="Введите барьер" />
                                    </b-form-group>
                                  </b-col>
                                  <b-col md="6">
                                    <b-row>
                                      <b-col md="6">
                                        <b-form-radio-group class="circle-block">
                                          <input class="circle-input" :required="bar.name !== ''" v-model="bar.status" :id="'red-'+key+'-'+i" value="red" type="radio"/>
                                          <label :for="'red-'+key+'-'+i" class="bg-danger circle" >
                                            <i class="icon-circle"></i>
                                          </label>
                                          <input class="circle-input" v-model="bar.status" :id="'yellow-'+key+'-'+i" value="yellow" type="radio"/>
                                          <label :for="'yellow-'+key+'-'+i" class="bg-warning circle">
                                            <i class="icon-circle"></i>
                                          </label>
                                          <input class="circle-input" v-model="bar.status" :id="'green-'+key+'-'+i" value="green" type="radio"/>
                                          <label :for="'green-'+key+'-'+i" class="bg-success circle">
                                            <i class="icon-circle"></i>
                                          </label>
                                          <label>
                                            <b-button style="margin: -40px 0 0 20px;" v-if="i>2" variant="danger" size="sm" @click="factor.bars.splice(i,1)"><i class="fa fa-trash"></i></b-button>
                                          </label>
                                        </b-form-radio-group>
                                      </b-col>
                                    </b-row>
                                  </b-col>
                                </b-row>
                                <b-row>
                                  <b-col md="6"></b-col>
                                  <b-col md="6">
                                    <b-button style="margin-left: 180px;" v-if="factor.bars.length <=10" class="pull-left" variant="success" size="sm" @click="factor.bars.push({name:'',status:''})"><i class="fa fa-plus"></i> Добавить</b-button>
                                  </b-col>
                                </b-row>
                              </b-form-group>
                            </b-col>
                          </b-row>
                        </b-card-body>
                      </b-card>
                      <b-row>
                        <b-col>
                          <b-form-textarea v-model="report.comment" required :disabled="this.report.is_send" placeholder="Комментарий специалиста по итогам этапа диагностики"></b-form-textarea>
                        </b-col>
                      </b-row>
                      <hr/>
                      <b-row>
                        <b-col>
                          <router-link :to="'/diagnost/' + id" class="btn btn-sm btn-outline">
                            <i class="fa fa-arrow-circle-left"></i>
                            Назад
                          </router-link>
                          <b-button-group class="pull-right">
                            <button :disabled="$v.$invalid" v-if="!report.is_send && hasFailed && (report.raw_data ? report.raw_data.length : 0) < 3 && this.factors.length < 6" @click="updateReport({status: 'secondary', reportData: factors})" type="button" class="btn btn-info btn-sm text-white">
                              <i class="fa fa-upload"></i>
                              Запросить иные страны и коды ТН ВЭД
                            </button>
                            <button v-if="report.is_send" @click="print" type="button" class="btn btn-primary btn-sm text-white">
                              <i class="fa fa-print"></i>
                              Распечатать
                            </button>
                            <button v-if="!report.is_send" @click="updateReport({reportData: factors})" type="button" class="btn btn-secondary btn-sm">
                              <i class="fa fa-save"></i>
                              В черновик
                            </button>
                            <button :disabled="$v.$invalid" v-if="!report.is_send" type="submit" class="btn btn-success btn-sm">
                              <i class="fa fa-dot-circle-o"></i>
                              Сохранить
                            </button>
                          </b-button-group>
                        </b-col>
                      </b-row>
                    </b-form>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import client from '../backend/client';
    import * as AppStorage from "../storage/appstorage";
    import { Switch as cSwitch } from '@coreui/vue'
    import FactorsResult from "./FactorsResult";
    import { required, minLength } from 'vuelidate/lib/validators';
    const barValidate = (bar) => {
        return bar.status !== '' ? bar.name !== '' : true;
    };
    export default {
        name: "DiagnostFactors",
        components: {
            FactorsResult,
            AppStorage,
            cSwitch
        },
        data: () => {
            return {
                company: null,
                report: null,
                id: null,
                labelTxt: {
                    dataOn: 'да',
                    dataOff: 'нет'
                },
                statusText: {
                    'success': 'Выявлены некритичные барьеры / не выявлены барьеры',
                    'warning': 'Выявлены барьеры, которые могут вызвать сложности при экспорте',
                    'danger': 'Выявлены критичные заградительные барьеры или более 5, которые могут вызвать сложности при экспорте',
                },
                factors: []
            }
        },
        mounted() {
            this.id = this.$route.params.id;
            client
                .get('api/enrolls/' + this.id + '/company')
                .then((res) => {
                    this.company = res.data;
                    this.report = this.company.enroll.reports.stop_factors_report;
                    this.factors = this.company.enroll.reports.stop_factors_report.report_data;
                    let forms = [];
                    this.factors.forEach((factor) => {
                        if(!factor.bars) {
                            factor.bars = [];
                            let i = 0;
                            while (i < 3) {
                                factor.bars.push({name: '', status: ''});
                                i++;
                            }
                        }
                        forms.push(factor);
                    })
                    this.factors = forms;
                    this.factors = this.cloneObj(this.factors)
                })
            ;
        },
        computed: {
            colors: function() {
                let colorsArray = [];
                this.factors.forEach((factor) => {
                    let colors = {red: 0, yellow: 0, green: 0, isFailed: false, status: 'success', statusText: this.statusText['success'], isBlock: false}
                    factor.bars.forEach((bar) => {
                        if (bar.status === 'red') {
                           colors.red++;
                        }
                        if (bar.status === 'yellow') {
                            colors.yellow++;
                        }
                        if (bar.green === 'green') {
                            colors.green++;
                        }
                    });
                    colors.isBlock = factor.isBlock;
                    colors.isFailed = colors.yellow >= 5 || colors.red > 0;

                    colors.status = colors.yellow >= 1 && colors.yellow < 5 && !colors.red ? 'warning' : 'success';
                    colors.status = colors.isFailed ? 'danger' : colors.status;

                    colors.statusText = this.statusText[colors.status];

                    colorsArray.push(colors);
                });
                return colorsArray;
            },
            hasFailed: function() {
                return this.colors.filter(color => color.isFailed && !color.isBlock).length > 0;
            },
            hasSuccess: function() {
                return this.colors.filter(color => color.status === 'success').length > 0;
            },
            hasWarning: function() {
                return this.colors.filter(color => color.status === 'warning').length > 0;
            }
        },
        validations: {
            factors: {
                $each: {
                    product: {
                        required,
                        minLength: minLength(3),
                    },
                    bars: {
                        $each: {
                            barValidate
                        }
                    }
                }
            }
        },
        methods: {
            print() {
                let block = window.open('', 'PRINT');
                block.document.write('<html><head>');
                block.document.write('<style>@page { size: portrait;}</style>');
                block.document.write('</head><body>');
                block.document.write(document.getElementById('print').innerHTML);
                block.document.write('</body></html>');
                block.document.close();
                block.focus();
                block.print();
                block.close();
                return true;
            },
            cloneObj(src) {
              return JSON.parse(JSON.stringify(src));
            },
            updateReport(params, message = true, validate = true) {
                if (validate) {
                    let isError = false;
                    this.factors.forEach((factor, factorKey) => {
                        factor.bars.forEach((bar, barKey) => {
                            if(bar.status !== '' && bar.name === '') {
                                this.factors[factorKey].bars[barKey].isError = true;
                                isError = true;
                            }
                        });
                    });
                    if(isError) {
                        return false;
                    }
                }

                let rawCount = this.report.raw_data ? this.report.raw_data.length : 0;
                if(params.reportData) {
                    let factors = [];
                    let newCount = 0;
                    params.reportData.forEach((factor,key) => {
                        factor.isFailed = this.colors[key].isFailed;
                        if(factor.isFailed && !factor.isBlock && params.status === 'secondary') {
                            newCount++;
                            if((rawCount + newCount) <= 3) {
                                factor.isNew = true;
                            }
                            factor.isBlock = true;
                        }

                        factors.push(factor);
                    });
                    params.reportData = factors;
                }


                if(params.isSend) {
                    this.$bvModal.msgBoxConfirm('При нажатии «Да» работа с формой завершится, произойдет подсчет данных и окончательное завершение этапа диагностики.', {
                        title: 'Подтвердите действие:',
                        okVariant: 'danger',
                        okTitle: 'Да',
                        cancelTitle: 'Нет',
                        hideHeaderClose: false,
                        centered: true
                    })
                        .then((res) => {
                            if(res) {
                                return client
                                    .put('api/crm/enrollreports/' + this.report.id, params)
                                    .then(res => {
                                        this.report = res.data;
                                        this.factors = res.data.report_data;
                                        if(message) {
                                            this.$toasted.show('Изменения сохранены', {type: 'success'});
                                        }
                                        if(this.report.status === 'danger' && this.report.is_send) {
                                            client
                                                .put('api/crm/companysparks/' + this.company.id, {
                                                    status: 'archive',
                                                }).then(() => {
                                                this.$toasted.show("По итогам этапа диагностики компания отправлена в Архив!", {type: 'error', duration: 3000});
                                            })
                                        }
                                    })
                            }
                        })
                } else {
                    return client
                        .put('api/crm/enrollreports/' + this.report.id, params)
                        .then(res => {
                            this.report = res.data;
                            this.factors = res.data.report_data;
                            if(message) {
                                this.$toasted.show('Изменения сохранены', {type: 'success'});
                            }
                            if(this.report.status === 'danger' && this.report.is_send) {
                                client
                                    .put('api/crm/companysparks/' + this.company.id, {
                                        status: 'archive',
                                    }).then(() => {
                                    this.$toasted.show("По итогам этапа диагностики компания отправлена в Архив!", {type: 'error', duration: 3000});
                                })
                            }
                        })
                }
            }
        }
    }
</script>

<style scoped>
    .circle {
      display: inline-block;
      line-height: 32px;
      width: 32px;
      height: 32px;
      border-radius: 50%;
      text-align: center;
      margin-right: 10px;
      cursor: pointer;
      position: relative;
    }
    .circle-input {
      visibility:hidden;
    }
    .icon-circle {
      display: block;
      position: absolute;
      top: 50%;
      left: 50%;
      margin: -8px -8px;
      height: 16px;
      width: 16px;
      line-height: 1;
      background: #fff;
      border-radius: 50%;
    }
    input:checked + label > .icon-circle {
      background: #6c757d;
    }
    .fixed {
      position: fixed;
      right: 50px;
      top: 130px;
      z-index: 1020;
      border: 1px solid #c8ced3;
    }
    .fixed > .btn {
      border-radius: 0;
    }
    .circle-block {
      margin-top: 10px;
    }
  .label {
    padding: 2px 3px;
    border-radius: 5px;
    font-weight: bold;
  }
</style>
